import { PROJECT_NAMESPACE } from 'common';

export const NAMESPACE = `${PROJECT_NAMESPACE}/App`;
export const APP_ERROR = `${NAMESPACE}/APP_ERROR`;
export const TOGGLE_APP_ERROR_VISIBILITY = `${NAMESPACE}/TOGGLE_APP_ERROR_VISIBILITY`;
export const CLEAR_ALL_ERRORS = `${NAMESPACE}/CLEAR_ALL_ERRORS`;



// WEBPACK FOOTER //
// ./src/containers/App/constants.js